const navItems = [
  { label: 'Início', href: '#home' },
  { label: 'Sobre Nós', href: '#sobre' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Diferenciais', href: '#diferenciais' },
  { label: 'Benefícios', href: '#beneficios' },
  { label: 'Contato', href: '#contato' },
];

const contactItems = [
  {
    icon: 'ri-mail-line',
    label: 'E-mail',
    value: 'contato@rcpinteligencia.com.br',
    href: 'mailto:contato@rcpinteligencia.com.br',
  },
  {
    icon: 'ri-whatsapp-line',
    label: 'WhatsApp',
    value: '(51) 99100-3410',
    href: 'https://wa.me/5551991003410',
  },
  {
    icon: 'ri-instagram-line',
    label: 'Instagram',
    value: '@inteligenciarcp',
    href: 'https://instagram.com/inteligenciarcp',
  },
  {
    icon: 'ri-map-pin-2-line',
    label: 'Localização',
    value: 'Porto Alegre, RS — Brasil',
    href: 'https://maps.app.goo.gl/1TcgT68RLkaxy5aL8',
  },
];

export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0c1e44] border-t border-[#c9a84c]/20">
      <div className="max-w-7xl mx-auto px-6 pt-8 pb-5">

        {/* Main grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-7">

          {/* Brand */}
          <div>
            <div className="mb-3">
              <span className="font-serif font-bold text-white text-xl tracking-tight">RCP</span>
              <span className="block text-[#c9a84c] text-xs font-semibold tracking-widest uppercase mt-0.5">
                Inteligência Contábil &amp; Tributária
              </span>
            </div>
            <p className="text-[#c9a84c]/60 text-xs font-medium tracking-widest uppercase mb-2">
              CRC RS 011307/O-2
            </p>
            <p className="text-white/50 text-sm leading-relaxed">
              A contabilidade com o olhar de quem audita. Controle, segurança e resultado real para o seu negócio.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h5 className="text-[#c9a84c] text-xs font-bold tracking-widest uppercase mb-3">
              Navegação
            </h5>
            <ul className="space-y-1.5">
              {navItems.map((item) => (
                <li key={item.href}>
                  <button
                    onClick={() => scrollTo(item.href)}
                    className="text-white/50 hover:text-[#c9a84c] text-sm transition-colors duration-150 cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h5 className="text-[#c9a84c] text-xs font-bold tracking-widest uppercase mb-3">
              Contato
            </h5>
            <ul className="space-y-2.5">
              {contactItems.map((item) => (
                <li key={item.label} className="flex items-center gap-2.5">
                  <div className="w-7 h-7 flex items-center justify-center bg-[#c9a84c]/10 border border-[#c9a84c]/20 rounded-md flex-shrink-0">
                    <i className={`${item.icon} text-[#c9a84c] text-sm`} />
                  </div>
                  {item.href ? (
                    <a
                      href={item.href}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="text-white/60 hover:text-[#c9a84c] text-sm transition-colors duration-150 cursor-pointer"
                    >
                      {item.value}
                    </a>
                  ) : (
                    <span className="text-white/60 text-sm">{item.value}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#c9a84c]/15 pt-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-white/30 text-xs">
            © 2026 RCP Inteligência Contábil &amp; Tributária. Todos os direitos reservados.
          </p>
          <p className="text-white/30 text-xs">CRC RS 011307/O-2 · Contabilidade com integridade</p>
        </div>

      </div>
    </footer>
  );
}
